export default __webpack_public_path__ + "static/19-45f11bfd70a1d0143268c25ac4c26525.jpg";